/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from "react";
import { InlineEdit } from "../../components/InlineEdit";
import { Button } from "../../components/Button";
import { useParams } from "react-router-dom";
import useSaveTemplate from "../../utils/customHooks";
import { SpinnerOverlay } from "../../utils/SpinnerOverlay";

export const Basnie33: React.FC = () => {
  const { pdfNameFromUrl } = useParams<{ pdfNameFromUrl: string }>();
  // Zaktualizowane teksty domyślne
  const [text1, setText1] = useState<string>("Pamiątka Chrztu Świętego Michałka");
  const [text2, setText2] = useState<string>("12.12.2021");
  const [text3, setText3] = useState<string>('Moje');
  const [text4, setText4] = useState<string>('Pierwsze');
  const [text5, setText5] = useState<string>("Bajeczki"); // Zmieniona data
  const [text6, setText6] = useState<string>("Z życzeniami Bożego Błogosławieństwa");
  const [text7, setText7] = useState<string>("Rodzice Chrzestni");

  // Zaktualizowane bazowe rozmiary czcionek
  const text1BasicSize = 50;
  const text2BasicSize = 40;
  const text3BasicSize = 40;
  const text4BasicSize = 38;
  const text5BasicSize = 38;
  const text6BasicSize = 38;
  const text7BasicSize = 38;
  const [fontSizeText1, setFontSizeText1] = useState<number>(text1BasicSize);
  const [fontSizeText2, setFontSizeText2] = useState<number>(text2BasicSize);
  const [fontSizeText3, setFontSizeText3] = useState<number>(text3BasicSize);
  const [fontSizeText4, setFontSizeText4] = useState<number>(text4BasicSize);
  const [fontSizeText5, setFontSizeText5] = useState<number>(text5BasicSize);
  const [fontSizeText6, setFontSizeText6] = useState<number>(text6BasicSize);
  const [fontSizeText7, setFontSizeText7] = useState<number>(text7BasicSize);
  const { saveTemplate, isSaving } = useSaveTemplate();

  const pdfWidth = "250mm"; // PDF width in mm
  const pdfHeight = "300mm"; // PDF height in mm
  const maxWidth = 800; // Maximum width for text
  const adjustFontSize = (
    text: string,
    currentFontSize: number,
    maxFontSize: number,
    minFontSize: number
  ) => {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    if (context) {
      let newFontSize = currentFontSize;
      context.font = `${newFontSize}px 'PLZurichItalic'`;
      let textWidth = context.measureText(text).width;

      while (textWidth > maxWidth && newFontSize > minFontSize) {
        newFontSize -= 1;
        context.font = `${newFontSize}px 'PLZurichItalic'`;
        textWidth = context.measureText(text).width;
      }

      while (textWidth < maxWidth * 0.9 && newFontSize < maxFontSize) {
        newFontSize += 1;
        context.font = `${newFontSize}px 'PLZurichItalic'`;
        textWidth = context.measureText(text).width;
      }

      return newFontSize;
    }

    return currentFontSize;
  };

  // Bramka ładowania fontu — bez tego canvas.measureText liczy szerokość fontem zastępczym
  // (sans-serif), który ma inne metryki niż PLZurichItalic. Skutek: rozmiar fontu jest źle
  // dopasowany i — częściej — przy nieudanym embeddzie font wraca do Garamonda w PDF.
  const ensureFont = () => document.fonts.load(`1em "PLZurichItalic"`);

  useEffect(() => {
    ensureFont().then(() =>
      setFontSizeText1(adjustFontSize(text1, fontSizeText1, text1BasicSize, 10))
    );
  }, [text1]);

  useEffect(() => {
    ensureFont().then(() =>
      setFontSizeText2(adjustFontSize(text2, fontSizeText2, text2BasicSize, 10))
    );
  }, [text2]);

  useEffect(() => {
    ensureFont().then(() =>
      setFontSizeText3(adjustFontSize(text3, fontSizeText3, text3BasicSize, 10))
    );
  }, [text3]);

  useEffect(() => {
    ensureFont().then(() =>
      setFontSizeText4(adjustFontSize(text4, fontSizeText4, text4BasicSize, 10))
    );
  }, [text4]);

  useEffect(() => {
    ensureFont().then(() =>
      setFontSizeText5(adjustFontSize(text5, fontSizeText5, text5BasicSize, 10))
    );
  }, [text5]);
  useEffect(() => {
    ensureFont().then(() =>
      setFontSizeText6(adjustFontSize(text6, fontSizeText6, text6BasicSize, 12))
    );
  }, [text6]);
  useEffect(() => {
    ensureFont().then(() =>
      setFontSizeText7(adjustFontSize(text7, fontSizeText7, text7BasicSize, 12))
    );
  }, [text7]);

  const handleSave = () => {
    saveTemplate(
      "printable-content",
      {
        pdfWidth: pdfWidth,
        pdfHeight: pdfHeight,
        pdfNameFromUrl: pdfNameFromUrl,
      },
      null,
      false
    );
  };

  return (
    <div style={{
      width: "100%",
      height: "100%",
      backgroundColor: "#ffffff", padding: "60px",
      position: "relative",
    }}>
      {/* Spinner Overlay */}
      <SpinnerOverlay isVisible={isSaving} />
      <div style={{ position: "absolute", top: "10px", left: "0px", right: "0px", margin: "auto", color: "white", width: "150px", height: "50px" }}>
        <Button onClick={handleSave} disabled={isSaving}>
          {isSaving ? "Zapisywanie..." : "Zapisz"}
        </Button>
      </div>

      <div
        id="printable-content"
        style={{
          position: "relative",
          width: pdfWidth,
          height: pdfHeight,
          fontFamily: "PLZurichItalic",
          backgroundColor: "#ffffff",
          margin: "auto",
        }}
      >
        <div className="sw-01-text-wrapper" style={{}}>
          <InlineEdit
            value={text1}
            setValue={setText1}
            style={{
              fontSize: `${fontSizeText1}px`,
              lineHeight: `${fontSizeText1}px`,
              width: `${maxWidth}px`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              position: 'absolute',
              top: '100px', // Zmienione położenie
              margin: 'auto',
              left: '0',
              right: '0',
              fontFamily: 'PLZurichItalic',
              color: "#ba7b81",
              zIndex: "12",
              textAlign: "center",
              fontWeight: "400",
            }}
          />
          <InlineEdit
            value={text2}
            setValue={setText2}
            style={{
              fontSize: `${fontSizeText2}px`,
              lineHeight: `${fontSizeText2}px`,
              width: `${maxWidth}px`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              position: 'absolute',
              top: '170px', // Zmienione położenie
              margin: 'auto',
              left: '0',
              right: '0',
              fontFamily: 'PLZurichItalic',
              color: "#ba7b81",
              zIndex: "12",
              textAlign: "center",
              fontWeight: "400",
              letterSpacing: "0.05em"
            }}
          />
          {/* <InlineEdit
            value={text3}
            setValue={setText3}
            style={{
              fontSize: `${fontSizeText3}px`,
              lineHeight: `${fontSizeText3}px`,
              width: `${maxWidth}px`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              position: 'absolute',
              bottom: '200px', // Zmienione położenie
              margin: 'auto',
              left: '0',
              right: '0',
              fontFamily: 'BaskervilleBoldItalic',
              color: "#96bee9",
              zIndex: "12",
              textAlign: "center",
              fontWeight: "400",
              letterSpacing: "0.0001em"
            }}
          />

          <InlineEdit
            value={text4}
            setValue={setText4}
            style={{
              fontSize: `${fontSizeText4}px`,
              lineHeight: `${fontSizeText4}px`,
              width: `${maxWidth}px`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              position: 'absolute',
              bottom: '150px', // Zmienione położenie
              margin: 'auto',
              left: '0',
              right: '0',
              fontFamily: 'BaskervilleBoldItalic',
              color: "#96bee9",
              zIndex: "12",
              textAlign: "center",
              fontWeight: "400",
            }}
          />

          <InlineEdit
            value={text5}
            setValue={setText5}
            style={{
              fontSize: `${fontSizeText5}px`,
              lineHeight: `${fontSizeText5}px`,
              width: `${maxWidth}px`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              position: 'absolute',
              bottom: '70px', // Zmienione położenie
              margin: 'auto',
              left: '0',
              right: '0',
              fontFamily: 'PLZurichItalic',
              color: "#d2aaab",
              zIndex: "12",
              textAlign: "center",
              fontWeight: "400",
            }}
          /> */}

          <InlineEdit
            value={text6}
            setValue={setText6}
            style={{
              fontSize: `${fontSizeText6}px`,
              lineHeight: `${fontSizeText6}px`,
              fontFamily: "PLZurichItalic",
              position: "absolute",
              bottom: "120px",
              left: "0px",
              right: "0px",
              // maxWidth: "120px",
              textAlign: "center",
              transform: "rotate(0deg)",
              fontWeight: "400",
              zIndex: "99",
              color: "#d2aaab"
            }}
          />
          <InlineEdit
            value={text7}
            setValue={setText7}
            style={{
              fontSize: `${fontSizeText7}px`,
              fontFamily: "PLZurichItalic",
              lineHeight: `${fontSizeText7}px`,
              position: "absolute",
              bottom: "70px",
              left: "0px",
              right: "0px",
              // maxWidth: "90px",
              textAlign: "center",
              transform: "rotate(0deg)",
              fontWeight: "400",
              zIndex: "99",
              color: "#d2aaab"
            }}
          />
        </div>


        <img
          src="/images/Basnie33.svg"
          style={{ width: "100%", height: "100%", position: 'absolute', top: '0', left: '0', zIndex: '2' }}
        />
      </div>
    </div>
  );
};